<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="disabled ? '详情' : materials.pkId ? '编辑' : '新建'"
      width="1000px"
      @close="$reset('form')">
    <el-form 
        ref="form" 
        :disabled="disabled" 
        :model="materials" 
        :rules="ruleValidate" 
        class="form" 
        label-width="80px">
      <el-row>
        <el-col v-if="materials.pkId" :span="12">
          <el-form-item label="物料编号">
            <el-input v-model.trim="materials.materialNO" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="物料类型" prop="materialTypeName">
            <el-input v-model="materials.materialTypeName" placeholder="请选择物料类型" readonly>
              <el-button slot="append" icon="el-icon-search" @click="$refs.selectMaterialType.open()"/>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="物料名称" prop="materialName">
            <el-input v-model.trim="materials.materialName" placeholder="请输入物料名称"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="规格型号">
            <el-input v-model.trim="materials.specification" placeholder="请输入规格型号"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Mrp类型" prop="mrpType">
            <el-select v-model="materials.mrpType" placeholder="请选择Mrp类型">
              <el-option label="自制" :value="2"/>
              <el-option label="采购" :value="1"/>
              <el-option label="委外" :value="3"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="单位" prop="unitName">
            <el-input v-model="materials.unitName" placeholder="请选择物料单位" readonly>
              <el-button slot="append" icon="el-icon-search" @click="$refs.unitSelect.open()"/>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="外部编号">
            <el-input v-model.trim="materials.outerNO" placeholder="请输入外部编号"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="标签编号">
            <el-input v-model.trim="materials.labelNo" placeholder="请输入标签编号"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="长度">
            <el-input v-model.trim="materials.mlength" placeholder="请输入物料长度"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="宽度">
            <el-input v-model.trim="materials.mwidth" placeholder="请输入物料宽度"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="高度">
            <el-input v-model.trim="materials.mheight" placeholder="请输入物料高度"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="净重">
            <el-input v-model.trim="materials.mnetWeight" placeholder="请输入物料净重"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="默认仓位">
            <el-input v-model="materials.warehouseLocationName" placeholder="请选择默认仓位" readonly>
              <el-button slot="append" icon="el-icon-search" @click="$refs.locationSelect.open()"/>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="有效期(月)">
            <el-input v-model.trim="materials.limitMonth" placeholder="请输入"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item v-if="show" label="图片上传" prop="imgUrl">
        <upload-file
            ref="upload"
            :imgurl="imgUrl"
            :auth-index="authIndex"
            @upload-success="uploadSuccess"
            @removeFile="materials.imgPath = ''"/>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button v-if="!disabled" :loading="submitLoading" type="primary" @click="submitHandle">确定</el-button>
    </span>
    <material-type-selector ref="selectMaterialType" @select="selectMaterialType"/>
    <unit-select ref="unitSelect" @select="unitSelect"/>
    <!-- 仓位选择 -->
    <location-select ref="locationSelect" @select="selectLocation"/>
  </el-dialog>
</template>

<script>
  import UnitSelect from "@/views/information/Unit/UnitSelect";
  import MaterialTypeSelector from "@/views/information/MaterialTypeName/MaterialTypeSelector";
  import LocationSelect from "@/views/information/WarehouseLocation/WarehouseLocationSelect.vue";
  import UploadFile from "@/components/ImgUpload.vue";

  export default {
    components: {
      UnitSelect,
      MaterialTypeSelector,
      LocationSelect,
      UploadFile,
    },
    data() {
      return {
        authIndex: this.$route.meta.authIndex,
        disabled: false,
        dialogVisible: false,
        submitLoading: false,
        dictionaryItemList: [],
        materials: {
          pkId: 0,
          // businessType: "",
          materialNO: "",
          materialTypeId: "",
          materialTypeName: "",
          materialName: "",
          specification: "",
          mrpType: "",
          outerNO: "",
          labelNo: "",
          unitName: "",
          measuringUnitID: "",
          unitNO: "",
          mlength: "",
          mwidth: "",
          mheight: "",
          mnetWeight: "",
          warehouseLocationName: "",
          warehouseLocationNo: "",
          locationNo: "",
          locationId: "",
          imgPath: "",
          limitMonth:0,
        },
        show: false,
        imgUrl: "",
        ruleValidate: {
          materialTypeName: { required: true, message: "请选择物料类型", trigger: "change" },
          materialName: { required: true, message: "请输入物料名称", trigger: "blur" },
          mrpType: { required: true, message: "请选择Mrp类型", trigger: "change" },
          unitName: { required: true, message: "请选择物料单位", trigger: "change" },
        },
      };
    },
    methods: {
      open(row, mark) {
        this.dialogVisible = true;
        this.show = true;
        this.disabled = mark;
        this.getDictionaryItemList("MATERIAL_BUSINESS_TYPE");
        if (row) {
          this.show = false;
          this.$nextTick(() => {
            this.getData(row.materialID);
          });
        }
      },

      getData(materialID) {
        this.contentLoading = true;
        this.$http
          .get("basic", `materials/${materialID}`)
          .then((resp) => {
            this.contentLoading = false;
            if (resp.success) {
              this.materials = Object.assign(this.materials, resp.data);
              this.materials.pkId = resp.data.materialID;
              if (this.materials.imgPath) {
                this.getImageUrl(this.materials.imgPath);
              }
            }
            this.show = true;
          })
          .catch(() => {
            this.contentLoading = false;
          });
      },

      // 获取业务类型
      getDictionaryItemList(type) {
        this.$http
          .get("basic", `dictionaries/getDictionaryItemList/${type}`)
          .then((resp) => {
            if (resp.success) {
              this.dictionaryItemList = resp.data;
              if (resp.data.length) {
                this.materials.businessType = resp.data[0].itemId;
              }
            }
          })
          .catch(() => {
            this.$message.error("获取业务类型失败");
          });
      },

      // 物料类型选择
      selectMaterialType(row) {
        this.materials.materialTypeName = row.name;
        this.materials.materialTypeId = row.id;
      },

      // 物料单位选择
      unitSelect(row) {
        this.materials.unitName = row.unitName;
        this.materials.measuringUnitID = row.pkId;
        this.materials.unitNO = row.unitNo;
      },

      // 仓位选择
      selectLocation(row) {
        this.materials.warehouseLocationName = row.warehouseLocationName;
        this.materials.warehouseLocationNo = row.warehouseLocationNo;
        this.materials.locationId = row.pkId;
      },

      submitHandle() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .save("basic", "materials", this.materials)
              .then((resp) => {
                this.submitLoading = false;
                if (resp.success) {
                  if (this.materials.pkId) {
                    this.$emit("save-success");
                    this.$message.success("编辑成功");
                  } else {
                    this.$emit("save-success");
                    this.$message.success("添加成功");
                  }
                  this.dialogVisible = false;
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },

      // 图片上传
      uploadSuccess(data) {
        this.materials.imgPath = data.key;
      },

      // 获取图片路劲
      getImageUrl(imgPath) {
        this.$http.get("basic", `files/getDownloadUrl?key=${encodeURIComponent(imgPath)}`).then((res) => {
          if (res.success) {
            this.imgUrl = res.data;
          }
        });
      },
    },
  };
</script>
